import React from 'react';
import { Image, Type } from '@spotify-internal/encore-creator-web';
import { colorThemeGenerator, ButtonPrimary } from '@spotify-internal/encore-creator-web';
import styled from 'styled-components';
import {
  white,
  spacer20,
  spacer48,
  screenMdMin,
  screenSmMin,
  midnight,
  screenSmMax,
} from '@spotify-internal/encore-foundation';
import { FormattedMessage } from 'react-intl';
import { pageConstraintStyles, PAGE_GUTTER } from './styles';

export function GimletAcademy() {
  return (
    <GimletAcademyWrapper>
      <GimletAcademyContainer>
        <GimletText>
          <Type as="h2" variant="heading2" style={{ marginBottom: spacer20 }}>
            <FormattedMessage
              id="landing-page.gimlet.want-to-learn"
              defaultMessage="Want to learn from the best?"
            />
          </Type>
          <GimeletAcademySubHeader>
            <FormattedMessage
              id="landing-page.gimlet.in-this-podcast"
              defaultMessage="In this podcast, Gimlet cofounder Alex Blumberg provides advanced tips — on topics like
          booking interviews, recording ‘good tape,’ and editing compelling stories — to help
          podcasters on Spotify take their shows to the next level."
            />
          </GimeletAcademySubHeader>
        </GimletText>
        <GimletButton>
          <ButtonPrimary
            href="https://open.spotify.com/show/7hhEbl4DOMheWRunCUAla6"
            target="_blank"
            rel="noopener noreferrer"
            theme={{
              ...colorThemeGenerator({
                primaryColor: midnight,
                primaryColorText: white,
                primaryColorFocusText: white,
                primaryColorActiveText: white,
              }),
            }}
          >
            <FormattedMessage id="landing-page.gimlet.listen-now" defaultMessage="Listen Now" />
          </ButtonPrimary>
        </GimletButton>

        <GimletAcademyImage
          src="/images/landing_page/gimlet-academy-cover.png"
          alt="Gimlet Academy cover"
        />
      </GimletAcademyContainer>
    </GimletAcademyWrapper>
  );
}

const GimletAcademyWrapper = styled.div`
  background-color: ${white};
  color: ${midnight};
`;

const GimletAcademyContainer = styled.div`
  ${pageConstraintStyles}

  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${spacer48};
  grid-template-areas:
    'txt'
    'btn'
    'img';
  padding: 54px 16px 80px;

  @media (min-width: ${screenMdMin}) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(50px, auto);
    grid-template-areas:
      'txt  img '
      'btn  img ';
    grid-column-gap: 58px;
    grid-row-gap: 0px;
    padding: 120px ${PAGE_GUTTER};
  }
`;

const GimletText = styled.div`
  grid-area: txt;
`;

const GimletButton = styled.div`
  grid-area: btn;
`;

const GimletAcademyImage = styled(Image)`
  grid-area: img;
  max-width: 330px;
  width: 100%;
  margin-bottom: ${spacer48};
  @media (max-width: ${screenSmMax}) {
    max-width: 160px;
    margin-bottom: 0px;
  }
`;

const GimeletAcademySubHeader = styled(Type).attrs({
  forwardedAs: 'p',
  variant: Type.heading4,
})`
  margin-bottom: 28px;
  @media (max-width: ${screenSmMin}) {
    text-align: left;
    margin-bottom: 0px;
  }
`;
